import React, { createContext, useState } from "react";
import PropTypes from "prop-types";
import { getBusinesscategoriesApi } from "Apis/businessApi";

export const BusinessSubCategoryContext = createContext();

export const BusinessSubCategoryContextProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [formIsEdit, setFormIsEdit] = useState(false);
  const [editData, setEditData] = useState({});
  const [categoriesList, setCategoriesList] = useState([]);

  const getCategoryApi = async (id) => {
    let response = await getBusinesscategoriesApi(id);
    if (response?.status === 200) {
      setCategoriesList(
        response.data.data.rows?.map((item) => ({
          id: parseInt(item?.id),
          label: item?.name,
        }))
      );
    }
  };

  const handleOpenModal = () => {
    setOpen(true);
    setFormIsEdit(false);
  };

  return (
    <BusinessSubCategoryContext.Provider
      value={{
        open,
        setOpen,
        formIsEdit,
        setFormIsEdit,
        handleOpenModal,
        editData,
        setEditData,
        categoriesList,
        setCategoriesList,
        getCategoryApi,
      }}
    >
      {children}
    </BusinessSubCategoryContext.Provider>
  );
};

export default BusinessSubCategoryContextProvider;
BusinessSubCategoryContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
